module.exports = __webpack_public_path__ + "static/media/block-second.7eec04ab.png";